import { render, staticRenderFns } from "./ImportedColdChainGoods.vue?vue&type=template&id=d6109aa2&scoped=true&"
import script from "./ImportedColdChainGoods.vue?vue&type=script&lang=js&"
export * from "./ImportedColdChainGoods.vue?vue&type=script&lang=js&"
import style0 from "./ImportedColdChainGoods.vue?vue&type=style&index=0&id=d6109aa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6109aa2",
  null
  
)

export default component.exports